import * as constants from '../Actions/types';
import initialState from './initial-state';

export default function(state = initialState.xpa, action) {
  switch (action.type) {
    
    case constants.GET_FEEDS:
      return { ...state, feeds: action.feeds, userid: action.userid || state.userid };
    
    case constants.LINK_FEED:
      return { ...state, 
                feeds: [ ...state.feeds.map(feed => feed.bankAccountId === action.payload.feed.bankAccountId ? 
                                                { ...feed, RAHBankAccountId: action.payload.feed.RAHBankAccountId, R1BankAccountId: action.payload.feed.R1BankAccountId } : feed) ],
                bankAccounts: [...action.payload.bankAccounts]};

    case constants.TOGGLE_FIELD:
        return { ...state, edit: action.payload, updateError: false, updated: false };

    case constants.REQUEST_UPDATE_FEED_ACCOUNTNAME:
        return { ...state, updating: true, updateError: false };

    case constants.UPDATE_FEED_ACCOUNTNAME_SUCCESS:
        return { ...state, updating: false, updateError: false, edit: false, updated: true,
                feeds: [ ...state.feeds.map(feed => feed.bankAccountId === action.payload.bankAccountId ? 
                                                { ...feed, accountName: action.payload.accountName } : feed) ]};

    case constants.UPDATE_FEED_ACCOUNTNAME_FAILURE:
        return { ...state, updating: false, updateError: true, error: action.payload };

    case constants.GET_USER_ID:
      return { ...state, userid: action.payload.userid, user: action.payload };

    case constants.GET_MAP_BANKS:
        return { ...state, bankAccounts: action.payload };

    case constants.GET_RAH_BANKACCOUNTS:
        return { ...state, bankAccounts: action.payload };
        
    case constants.REQUEST_LOGIN:
        return { ...state, loggingIn: true, loginError: action.payload };

    case constants.LOGIN_SUCCESS:
        return { ...state, loggingIn: false, loggedIn: true };
    
    case constants.LOGIN_FAILURE:
        return { ...state, loggingIn: false, loginError: action.payload };
    
    case constants.LOGOUT:
        return { ...state, error: action.payload, user: '', loggedIn: '' };

    case constants.REQUEST_RESET_PASSWORD:
        return { ...state, resetting: true, reset: '', error: ''}
  
    case constants.RESET_PASSWORD_SUCCESS:
        return { ...state, resetting: false, reset: true };
    
    case constants.RESET_PASSWORD_FAILURE:
        return { ...state, resetting: false, reset: false, error: action.error };
          
    case constants.REQUEST_SET_PASSWORD:
        return { ...state, setting: true, error: ''}
    
    case constants.SET_PASSWORD_SUCCESS:
        return { ...state, setting: false, set: true, loggedIn: false };
    
    case constants.SET_PASSWORD_FAILURE:
        return { ...state, setting: false, error: action.error };

    case constants.CLEAR_XPA_STATE:
        return { ...state, setting: false, set: false, error: '' };    

    case constants.REQUEST_FAILURE:
        return { ...state, error: action.payload, user: '', loggedIn: false };

    case constants.NO_ERROR_RESPONSE:
        return { ...state, error: action.payload };

    case constants.SET_ERROR:
        return { ...state, error: action.payload };

    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/reducers/xpaReducer.js